import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=1349d4ac&"
import script from "./DateInput.vue?vue&type=script&lang=ts&"
export * from "./DateInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports